import { queryOptions } from '@tanstack/react-query';
import API, { type CreditFeaturesResponse, type FeaturesResponse } from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';
import { EXTENDED_STALE_TIME } from '@/constants/constants';
import { type ProductName, ProductNames } from '@/constants/ProductNames';

type ProductFeaturesResponse = CreditFeaturesResponse | FeaturesResponse;

export const creditFeaturesQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.creditFeatures,
    queryFn: API.credit.getFeatures,
    staleTime: EXTENDED_STALE_TIME,
  });

const featuresQueryConfig = {
  [ProductNames.CREDIT]: {
    queryKey: queryKeys.creditFeatures,
    queryFn: (): Promise<ProductFeaturesResponse> => API.credit.getFeatures(),
  },
  [ProductNames.DEBT_CONSOLIDATION]: {
    queryKey: queryKeys.debtConsolidationFeatures,
    queryFn: (): Promise<ProductFeaturesResponse> => API.debtConsolidation.getFeatures(),
  },
  [ProductNames.LOAN]: {
    queryKey: queryKeys.loanFeatures,
    queryFn: (): Promise<ProductFeaturesResponse> => API.SE.loan.getFeaturesSteps(),
  },
};

export const featuresQueryOptions = (productName: ProductName) =>
  queryOptions({
    ...featuresQueryConfig[productName],
    staleTime: EXTENDED_STALE_TIME,
  });
